import { render } from "./CompoundMix.vue?vue&type=template&id=0756a79d&ts=true"
import script from "./CompoundMix.vue?vue&type=script&lang=ts"
export * from "./CompoundMix.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__